const Like = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props}>
        <use xlinkHref="#lksmbl" />
    </svg>
);

export default Like;
